// document.addEventListener('DOMContentLoaded', function () {
//     const video = document.getElementById('hero-video');
//     const source = document.getElementById('hero-video-source');

//     if (!video || !source) return;

//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;

//     // Detect Apple devices
//     const isIOS =
//         /iPad|iPhone|iPod/.test(userAgent) ||
//         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

//     const isMacOS = /Macintosh/.test(userAgent);

//     // Apple devices → HEVC MP4
//     if (isIOS || isMacOS) {
//         source.src = source.dataset.hevc;
//         //source.src = 'https://cdn.shopify.com/videos/c/o/v/8235e49368f643ee9f184a580c55f378.mp4';
//         source.type = 'video/mp4';
//     }
//     // Windows / Android / other devices → WebM
//     else {
//         source.src = source.dataset.webm;
//         //source.src = 'https://cdn.shopify.com/videos/c/o/v/f3f72eed8ec74e83a1721bdf042caca1.webm';
//         source.type = 'video/webm';
//     }

//     video.load();
// });


document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.mtw5-exp-page video');

    if (!videos.length) return;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect Apple devices
    const isIOS =
        /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const isMacOS = /Macintosh/.test(userAgent);

    videos.forEach(function (video) {
        const source = video.querySelector('source');

        if (!source) return;

        // Apple devices → HEVC MP4
        if (isIOS || isMacOS) {
            source.src = source.dataset.hevc;
            source.type = 'video/mp4';
        }

        // Windows / Android / other devices → WebM
        else {
            source.src = source.dataset.webm;
            source.type = 'video/webm';
        }

        video.load();
    });
});


$(document).ready(function () {

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    let smoother = ScrollSmoother.create({
        smooth: 2,
        effects: true,
        normalizeScroll: true
    });

    window.pageSmoother = smoother;

    // ScrollSmoother fixes #smooth-wrapper as position:fixed on desktop,
    // hiding anything outside it. Move footer-bottom into smooth-content
    // at runtime so it appears at the bottom of the scroll content.
    if (window.innerWidth > 1280) {
        var footerBottomEl = document.querySelector('.shopify-section-group-footer-group');
        if (footerBottomEl) {
            document.getElementById('smooth-content').appendChild(footerBottomEl);
            smoother.refresh();
        }
    }

    // Reload when the desktop â†” mobile breakpoint is crossed during resize
    (function () {
        var wasMobile = window.innerWidth <= 1280;
        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                var isMobile = window.innerWidth <= 1280;
                if (isMobile !== wasMobile) {
                    window.location.reload();
                }
            }, 250);
        });
    })();

    if ($(window).innerWidth() > 1280) {

        (function () {

            var videos = document.querySelectorAll('video.desktop');
        
            videos.forEach(function (video) {
        
                // Exclude intro section
                if (video.closest('#mtw5-intro-section, .mtw5-intro-section')) {
                    return;
                }
        
                // Pause initially
                video.pause();
        
                // Reset to beginning if required
                try {
                    video.currentTime = 0;
                } catch (e) {}
        
            });
        
            var sections = document.querySelectorAll('section');
        
            sections.forEach(function (section) {
        
                // Exclude intro section
                if (
                    section.id === 'mtw5-intro-section' ||
                    section.classList.contains('mtw5-intro-section')
                ) {
                    return;
                }
        
                var sectionVideos = section.querySelectorAll('video');
        
                if (!sectionVideos.length) return;
        
                var observer = new IntersectionObserver(function (entries) {
        
                    entries.forEach(function (entry) {
        
                        if (entry.isIntersecting) {
        
                            // Section entered viewport → PLAY
                            sectionVideos.forEach(function (video) {

                                try {
                                    video.currentTime = 0;
                                } catch (e) {}
        
                                setTimeout(()=>{
                                    video.play().catch(function () {});
                                },500)
        
                            });
        
                        } else {
        
                            // Section left viewport → PAUSE
                            sectionVideos.forEach(function (video) {
        
                                video.pause();

                                try {
                                    video.currentTime = 0;
                                } catch (e) {}
        
                            });
        
                        }
        
                    });
        
                }, {
                    threshold: 0.15
                });
        
                observer.observe(section);
        
            });
        
        })();

        // mtw5-intro-section
        var introSection = document.getElementById('mtw5-intro-section');

        if (introSection) {
            var introContent = introSection.querySelector('.mtw5-intro-content');
            var introPhone = introSection.querySelector('.mtw5-intro-phone');
            var introPara = introSection.querySelector('.mtw5-intro-para-1');
            var introMouseScroll = introSection.querySelector('.mtw5-mouse-scrolling');

            var iPhase = 0;
            var iLocked = false;
            var iActive = false;
            var iSectionTop = 0;
            var iN = 3;
            var iVH = window.innerHeight;

            gsap.set(introContent, { y: iVH, opacity: 0 });
            gsap.set(introPhone, { y: iVH, opacity: 0 });
            gsap.set(introPara, { y: iVH, opacity: 0 });

            function introGoTo(idx) {
                var prev = iPhase;

                iPhase = Math.max(0, Math.min(iN - 1, idx));

                function syncScroll() {
                    // Don't force scroll position at the final phase.
                    // Allow the page to naturally continue to the next section.
                    if (iPhase >= iN - 1) {
                        iLocked = false;
                        return;
                    }
                
                    var syncPosition = iSectionTop + iPhase * window.innerHeight;
                
                    window.scrollTo({
                        top: syncPosition,
                        left: 0,
                        behavior: 'auto'
                    });
                }

                // SCROLL DOWN
                if (iPhase > prev) {

                    // Phase 1: Show intro content
                    if (iPhase === 1) {
                        gsap.to(introContent, {
                            y: 0,
                            opacity: 1,
                            duration: 0.6,
                            ease: 'power3.out',
                            overwrite: true,
                            onComplete: function () {
                                syncScroll();
                                iLocked = false;
                            }
                        });

                    // Phase 2: Show phone + paragraph
                    } else if (iPhase === 2) {

                        gsap.to(introPhone, {
                            y: 0,
                            opacity: 1,
                            duration: 0.6,
                            ease: 'power3.out',
                            overwrite: true
                        });
                    
                        gsap.to(introPara, {
                            y: 0,
                            opacity: 1,
                            duration: 0.6,
                            ease: 'power3.out',
                            overwrite: true,
                            delay: 0.5,
                            onComplete: function () {
                    
                                iLocked = false;
                    
                                gsap.to(introMouseScroll, {
                                    opacity: 0,
                                    duration: 0.4,
                                    ease: 'power3.in',
                                    onComplete: function () {
                                        introMouseScroll.style.visibility = 'hidden';
                                    }
                                });
                            }
                        });
                    } else {
                        iLocked = false;
                    
                        // Let ScrollTrigger release naturally after final animation
                        if (iPhase === iN - 1) {
                            requestAnimationFrame(function () {
                                window.scrollTo({
                                    top: iSectionTop + (iN * window.innerHeight),
                                    left: 0,
                                    behavior: 'auto'
                                });
                            });
                        }
                    }

                // SCROLL UP
                } else {

                    // Back to Phase 1
                    if (iPhase === 1) {

                        introMouseScroll.style.visibility = 'visible';

                        gsap.to(introMouseScroll, {
                            opacity: 1,
                            duration: 0.4,
                            ease: 'power3.out',
                            overwrite: true
                        });

                        gsap.to(introPhone, {
                            y: iVH,
                            opacity: 0,
                            duration: 0.6,
                            ease: 'power3.in',
                            overwrite: true
                        });

                        gsap.to(introPara, {
                            y: iVH,
                            opacity: 0,
                            duration: 0.6,
                            ease: 'power3.in',
                            overwrite: true,
                            onComplete: function () {
                                syncScroll();
                                iLocked = false;
                            }
                        });

                    // Back to Phase 0
                    } else if (iPhase === 0) {

                        gsap.to(introContent, {
                            y: iVH,
                            opacity: 0,
                            duration: 0.6,
                            ease: 'power3.in',
                            overwrite: true,
                            onComplete: function () {
                                syncScroll();
                                iLocked = false;
                            }
                        });

                    } else {
                        iLocked = false;
                    }
                }
            }

            var iLockTimer = null;

            ScrollTrigger.create({
                trigger: introSection,
                start: 'top top',
                end: '+=' + (iN - 1) * 100 + '%',
                pin: true,
                anticipatePin: 1,
                scrub: 0.5,

                onEnter: function (self) {
                    iActive = true;
                    iPhase = 0;
                    iSectionTop = self.start;
                    iLocked = false;
                },

                onLeave: function () {
                    iActive = false;

                    if (iLockTimer) {
                        clearTimeout(iLockTimer);
                        iLockTimer = null;
                    }

                    iLocked = false;
                },

                onEnterBack: function (self) {
                    iActive = true;
                    iSectionTop = self.start;
                    iPhase = iN - 1;
                    iLocked = false;
                },

                onLeaveBack: function () {
                    iActive = false;

                    if (iLockTimer) {
                        clearTimeout(iLockTimer);
                        iLockTimer = null;
                    }

                    iLocked = false;
                }
            });

            // Mouse wheel
            introSection.addEventListener('wheel', function (e) {
                if (!iActive) return;

                var dir = e.deltaY > 0 ? 1 : -1;
                var next = iPhase + dir;

                if (next < 0 || next >= iN) {
                    if (iLocked) {
                        e.preventDefault();
                    }
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                if (iLocked) return;

                iLocked = true;

                introGoTo(next);

                if (iLockTimer) {
                    clearTimeout(iLockTimer);
                }

                iLockTimer = setTimeout(function () {
                    iLocked = false;
                    iLockTimer = null;
                }, 1500);
            }, { passive: false });

            // Touch
            var iTouchY = 0;

            introSection.addEventListener('touchstart', function (e) {
                iTouchY = e.touches[0].clientY;
            }, { passive: true });

            introSection.addEventListener('touchend', function (e) {
                if (!iActive) return;

                var dy = iTouchY - e.changedTouches[0].clientY;

                if (Math.abs(dy) < 40) return;

                var next = iPhase + (dy > 0 ? 1 : -1);

                if (next < 0 || next >= iN) return;
                if (iLocked) return;

                iLocked = true;

                introGoTo(next);

                if (iLockTimer) {
                    clearTimeout(iLockTimer);
                }

                iLockTimer = setTimeout(function () {
                    iLocked = false;
                    iLockTimer = null;
                }, 1500);
            });

            // Keyboard
            document.addEventListener('keydown', function (e) {
                if (!iActive) return;

                if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

                var dir = e.key === 'ArrowDown' ? 1 : -1;
                var next = iPhase + dir;

                if (next < 0 || next >= iN) return;

                e.preventDefault();

                if (iLocked) return;

                iLocked = true;

                introGoTo(next);

                if (iLockTimer) {
                    clearTimeout(iLockTimer);
                }

                iLockTimer = setTimeout(function () {
                    iLocked = false;
                    iLockTimer = null;
                }, 1500);
            });
        }

        // mtw5-adaptive-noise-section
        const adaptiveSection = document.getElementById("mtw5-adaptive-noise-section");
        if (adaptiveSection) {

            const stickyScene = adaptiveSection.querySelector(".sticky-scene");

            const bg1 = adaptiveSection.querySelectorAll(".bg1");
            const bg2 = adaptiveSection.querySelectorAll(".bg2");

            const title1 = adaptiveSection.querySelector(".title-1");
            const title2 = adaptiveSection.querySelector(".title-2");

            // Initial State
            gsap.set(bg1, { opacity: 1 });
            gsap.set(bg2, { opacity: 0 });

            gsap.set(title1, {
                opacity: 0,
                y: 30
            });

            gsap.set(title2, {
                opacity: 0,
                y: 30
            });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: stickyScene,
                    start: "top top",
                    end: "+=300%",
                    pin: true,
                    scrub: 0.5,
                    anticipatePin: 1
                }
            });

            tl.to(title1, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power3.out"
            });

            tl.to(title1, {
                opacity: 0,
                y: -30,
                duration: 0.6,
                ease: "power3.out"
            },);

            tl.to(bg1, {
                opacity: 0,
                duration: 0.6,
                ease: "power3.out"
            }, "a");

            tl.to(bg2, {
                opacity: 1,
                duration: 0.5,
                ease: "power3.out"
            }, "a");

            tl.to(title2, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power3.out",
                delay: 0.5,
            });

        }

        // Discover Text Section
        var discoverSection = document.querySelector('.mtw5-discover-text-section');
        var discoverP = discoverSection && discoverSection.querySelector('p');
        var discoverBlob = discoverSection && discoverSection.querySelector('.blue-blob-block');
        if (discoverSection && discoverP) {
            var splitDiscover = new SplitText(discoverP, { type: 'words', wordsClass: 'word' });
            gsap.set(splitDiscover.words, { color: '#818183' });
            gsap.set(discoverP, { opacity: 0, y: '100%' });

            var discoverTl = gsap.timeline({
                scrollTrigger: {
                    trigger: discoverSection,
                    start: 'top top',
                    end: '+=200%',
                    pin: true,
                    anticipatePin: 1,
                    scrub: 0.5,
                    onEnter: function () {
                        if ($("body").find("mtw5-exp-page")) {
                            $("body").addClass("mtw5-discover-active");
                        }
                    },

                    onLeaveBack: function () {
                        if ($("body").find("mtw5-exp-page")) {
                            $("body").removeClass("mtw5-discover-active");
                        }
                    }
                }
            });

            if (discoverBlob) {
                discoverTl.fromTo(discoverBlob,
                    {
                        x: window.innerWidth * 0.80,
                        y: window.innerHeight * 0.70,
                    },
                    {
                        x: 0,
                        y: 0,
                        duration: 3,
                        ease: 'power3.inOut',
                    },
                    2.2
                );
            }

            // paragraph slides up from bottom (grey)
            discoverTl.fromTo(discoverP,
                { opacity: 0.15, y: '50%' },
                { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' },
                0.5
            );

            // words highlight grey â†’ white
            discoverTl.fromTo(splitDiscover.words,
                { color: '#818183' },
                {
                    color: '#ffffff',
                    ease: 'power3.out',
                    stagger: { each: 0.15, from: 'start' },
                },
                1.2
            );
        }

        // product expanded section
        var productExpandedSection = $(".mtw5-product-expanded-section");
        var driverLine1 = $(".mtw5-product-expanded-section .mtw5-driver-line-1");
        var driverLine2 = $(".mtw5-product-expanded-section .mtw5-driver-line-2");
        var productExpandedParagraphs = $(".mtw5-product-expanded-section .caption-wrap p");

        if (
            productExpandedSection.length &&
            driverLine1.length
        ) {
            var p1 = productExpandedParagraphs[0];
            // var p2 = productExpandedParagraphs[1];

            // split each paragraph into word spans
            var splitP1 = new SplitText(p1, { type: 'words', wordsClass: 'word' });
            // var splitP2 = new SplitText(p2, { type: 'words', wordsClass: 'word' });

            // initialise words to gray; hide p2 below
            gsap.set(splitP1.words, { color: '#818183' });
            // gsap.set(splitP2.words, { color: '#818183' });
            // gsap.set(p2, { opacity: 0, y: '100%' });

            // hide both title lines initially below their container
            gsap.set(driverLine1, { y: '500', opacity: 0 });
            gsap.set(driverLine2, { y: '500', opacity: 0 });

            var productExpTl = gsap.timeline({
                scrollTrigger: {
                    trigger: productExpandedSection,
                    start: 'top top',
                    end: '+=300%',
                    pin: true,
                    anticipatePin: 1,
                    scrub: 0.5,
                }
            });

            // line 1 "42 mm driver," slides up first
            productExpTl.to(
                driverLine1,
                { opacity: 1, y: 0, duration: 0.3, ease: 'power3.out' }
            );

            // line 2 "big on detail." slides up after line 1
            productExpTl.to(
                driverLine2,
                { opacity: 1, y: 0, duration: 0.3, ease: 'power3.out' },
                "+=0.1"
            );

            // p1: slides in from bottom
            productExpTl.fromTo(
                p1,
                { opacity: 0, y: '100%' },
                { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' },
                "+=0.2"
            );

            // p1: word by word gray â†’ white
            productExpTl.to(splitP1.words, {
                color: '#ffffff',
                duration: 0.3,
                ease: 'power3.out',
                stagger: { each: 0.05, from: 'start' },
            });

            // p1 exits upward
            // productExpTl.to(p1, { y: '-110%', opacity: 0, duration: 0.5, ease: 'power3.in' }, "+=0.3");

            // p2: slides in from bottom as p1 exits
            // productExpTl.fromTo(
            //     p2,
            //     { opacity: 0, y: '100%' },
            //     { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' },
            //     "<0.2"
            // );

            // p2: word by word gray â†’ white
            // productExpTl.to(splitP2.words, {
            //     color: '#ffffff',
            //     duration: 0.3,
            //     ease: 'power3.out',
            //     stagger: { each: 0.05, from: 'start' },
            // });
        }

        // smart-control-app section (Customizable Sound)
        var scaSection = document.querySelector('.mtw5-smart-control-app-section');
        var scaEyebrow = document.querySelector('.mtw5-sca-eyebrow');
        var scaHeading = document.querySelector('.mtw5-sca-heading');
        var scaBody = document.querySelector('.mtw5-sca-body');
        var scaMedia = document.querySelector('.mtw5-smart-control-app-section .mtw5-sca-media');

        if (scaSection && scaEyebrow && scaHeading) {

            gsap.set([scaEyebrow, scaHeading], { opacity: 0, y: 80 });
            if(scaMedia) {
                gsap.set([scaMedia], { opacity: 0, y: 50});
            }


            var scaTl = gsap.timeline({
                scrollTrigger: {
                    trigger: scaSection,
                    start: 'top top',
                    end: '+=200%',
                    pin: true,
                    anticipatePin: 1,
                    scrub: 0.5,
                }
            });

            // eyebrow + heading rise together from bottom
            scaTl.to([scaEyebrow, scaHeading], {
                opacity: 1,
                y: 0,
                duration: 0.5,
                ease: 'power3.out',
                stagger: 0.15,
            });

            if(scaBody) {
                var splitScaBody = new SplitText(scaBody, { type: 'words', wordsClass: 'word' });
                gsap.set(splitScaBody.words, { color: '#818183' });
                gsap.set(scaBody, { opacity: 0, y: 40 });
                
                // paragraph slides in after a pause
                scaTl.to(scaBody, {
                    opacity: 1,
                    y: 0,
                    duration: 0.4,
                    ease: 'power3.out',
                }, '+=0.3');
    
                // words highlight gray â†’ white
                scaTl.to(splitScaBody.words, {
                    color: '#ffffff',
                    duration: 0.3,
                    ease: 'power3.out',
                    stagger: { each: 0.04, from: 'start' },
                }, '<0.1');
            }


            if(scaMedia) {
                scaTl.to([scaMedia], {
                    opacity: 1,
                    y: 0,
                    duration: 0.5,
                    ease: 'power3.out',
                });
            }

        }

        // lossless section
        function initLosslessAnimation(section) {
            var $section = $(section);
            var losslessContent = $section.find(".content-wrap");
            var losslessP = section.querySelector("p");
            // var losslessVideo = section.querySelector("video");

            // if (losslessVideo) losslessVideo.pause();
            // var losslessVidTriggered = false;

            if ($section.length) {
                var losslessTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: $section,
                        start: 'top top',
                        end: '+=200%',
                        pin: true,
                        anticipatePin: 1,
                        scrub: 0.5,
                    },
                    onUpdate: function () {
                        // if (!losslessVidTriggered && this.progress() >= 0.25) {
                        //     losslessVidTriggered = true;
                        //     if (losslessVideo) losslessVideo.play();
                        // }
                    }
                });

                // content-wrap (blue-text + h2) â€” original slide-up behaviour
                losslessTl.fromTo(losslessContent,
                    { opacity: 0, y: '100%' },
                    { opacity: 1, y: 0, ease: 'power3.out', duration: 0.4 }
                );

                // video fades in â€” original behaviour
                // losslessTl.fromTo(losslessVideo,
                //     { opacity: 1, ease: 'power3.out', duration: 0.4 }
                // );

                if (losslessP) {
                    var splitLossless = new SplitText(losslessP, { type: 'words', wordsClass: 'word' });
                    gsap.set(splitLossless.words, { color: '#818183' });
                    gsap.set(losslessP, { opacity: 0 });

                    // paragraph slides up from below with grey words
                    losslessTl.fromTo(losslessP,
                        { opacity: 0, y: '100%' },
                        { opacity: 1, y: 0, ease: 'power3.out', duration: 0.4 },
                        '+=0.3'
                    );

                    // words highlight grey â†’ white word by word
                    losslessTl.fromTo(splitLossless.words,
                        { color: '#818183' },
                        {
                            color: '#ffffff',
                            ease: 'power3.out',
                            delay: 0.2,
                            stagger: { each: 0.4, from: 'start' },
                        },
                        '+=0.3'
                    );
                }

            }

        }

        $(".mtw5-lossless-section").each(function () {
            initLosslessAnimation(this);
        });


        // mtw5-sound-revelation-sectionS
        var srvSection = document.getElementById('mtw5-sound-revelation-section');
        if (srvSection) {
            gsap.registerPlugin(SplitText);

            var srvHeadline = srvSection.querySelector('.mtw5-srv-headline');
            var srvPhone = srvSection.querySelector('.mtw5-srv-phone');
            var srvPara = srvSection.querySelector('.mtw5-srv-para');
            var srvBtn = srvSection.querySelector('.mtw5-srv-btn');

            var srvVH = window.innerHeight;
            var srvPhase = 0;
            var srvLocked = false;
            var srvActive = false;
            var srvSecTop = 0;
            var srvN = 5; // phases 0-4
            var srvLockTimer = null;

            // Split paragraph words for highlight effect (phase 3)
            var srvSplit = new SplitText(srvPara, { type: 'words' });
            var srvWords = srvSplit.words;
            gsap.set(srvWords, { color: '#818183' });

            // Initial hidden states
            gsap.set(srvHeadline, { y: srvVH, opacity: 0 });
            gsap.set(srvPhone, { y: srvVH, opacity: 0 });
            gsap.set(srvPara, { y: srvVH, opacity: 0 });
            gsap.set(srvBtn, { y: srvVH, opacity: 0 });

            function unlockScrollAfterDelay(duration) {
                if (srvLockTimer) clearTimeout(srvLockTimer);
                srvLockTimer = setTimeout(function () {
                    srvLocked = false;
                    srvLockTimer = null;
                }, duration);
            }

            function srvGoTo(idx) {
                var prev = srvPhase;
                srvPhase = Math.max(0, Math.min(srvN - 1, idx));

                if (srvPhase > prev) {
                    if (srvPhase === 1) {
                        gsap.to(srvHeadline, { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out', overwrite: true });
                        gsap.to(srvPhone, { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out', overwrite: true });
                        unlockScrollAfterDelay(500);
                    } else if (srvPhase === 2) {
                        // Very fast paragraph animation
                        gsap.to(srvPara, { y: 0, opacity: 1, duration: 0.2, ease: 'power3.out', overwrite: true });
                        unlockScrollAfterDelay(175);
                    } else if (srvPhase === 3) {
                        // Very fast text animation: minimal stagger
                        gsap.to(srvWords, {
                            color: '#fff',
                            stagger: { each: 0.03, from: 'start' },
                            delay: 0.02,
                            duration: 0.1,
                            ease: 'power3.out',
                            overwrite: true
                        });
                        unlockScrollAfterDelay(150);
                    } else if (srvPhase === 4) {
                        // Very fast button appearance
                        gsap.to(srvBtn, { y: 0, opacity: 1, duration: 0.1, ease: 'power3.out', overwrite: true });
                        unlockScrollAfterDelay(35);
                    } else {
                        srvLocked = false;
                    }
                } else {
                    if (srvPhase === 3) {
                        // Button exits downward - very fast
                        gsap.to(srvBtn, { y: srvVH, opacity: 0, duration: 0.1, ease: 'power3.in', overwrite: true });
                        unlockScrollAfterDelay(35);
                    } else if (srvPhase === 2) {
                        // Words un-highlight right-to-left very fast
                        gsap.to([].slice.call(srvWords).reverse(), {
                            color: '#818183',
                            stagger: { each: 0.02, from: 'start' },
                            duration: 0.12,
                            ease: 'power3.out',
                            overwrite: true
                        });
                        unlockScrollAfterDelay(150);
                    } else if (srvPhase === 1) {
                        // Paragraph exits very fast, reset word colours after exit
                        gsap.to(srvPara, { y: srvVH, opacity: 0, duration: 0.15, ease: 'power3.in', overwrite: true });
                        gsap.delayedCall(0.15, function () { gsap.set(srvWords, { color: '#818183' }); });
                        unlockScrollAfterDelay(200);
                    } else if (srvPhase === 0) {
                        gsap.to(srvHeadline, { y: srvVH, opacity: 0, duration: 0.3, ease: 'power3.in', overwrite: true });
                        gsap.to(srvPhone, { y: srvVH, opacity: 0, duration: 0.6, ease: 'power3.in', overwrite: true });
                        unlockScrollAfterDelay(100);
                    } else {
                        srvLocked = false;
                    }
                }

                var syncScroll = srvSecTop + srvPhase * window.innerHeight;
                if (srvPhase >= srvN - 1) syncScroll -= 1;
                window.scrollTo({ top: syncScroll, left: 0, behavior: 'auto' });
            }

            ScrollTrigger.create({
                trigger: srvSection,
                start: 'top top',
                end: '+=' + (srvN - 1) * 100 + '%',
                scrub: 0.5,
                pin: true,
                anticipatePin: 1,
                onEnter: function (self) {
                    srvActive = true;
                    srvPhase = 0;
                    srvSecTop = self.start;
                    srvLocked = false;
                },
                onLeave: function () {
                    srvActive = false;
                    if (srvLockTimer) { clearTimeout(srvLockTimer); srvLockTimer = null; }
                    srvLocked = false;
                },
                onEnterBack: function (self) {
                    srvActive = true;
                    srvSecTop = self.start;
                    srvPhase = srvN - 1;
                    srvLocked = false;
                },
                onLeaveBack: function () {
                    srvActive = false;
                    if (srvLockTimer) { clearTimeout(srvLockTimer); srvLockTimer = null; }
                    srvLocked = false;
                }
            });

            window.addEventListener('wheel', function (e) {
                if (!srvActive) return;
                var dir = e.deltaY > 0 ? 1 : -1;
                var next = srvPhase + dir;
                if (next < 0 || next >= srvN) {
                    if (srvLocked) e.preventDefault();
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                if (srvLocked) return;
                srvLocked = true;
                srvGoTo(next);
            }, { passive: false });

            var srvTouchY = 0;
            srvSection.addEventListener('touchstart', function (e) {
                srvTouchY = e.touches[0].clientY;
            }, { passive: true });
            srvSection.addEventListener('touchend', function (e) {
                if (!srvActive || srvLocked) return;
                var dy = srvTouchY - e.changedTouches[0].clientY;
                if (Math.abs(dy) < 40) return;
                var next = srvPhase + (dy > 0 ? 1 : -1);
                if (next < 0 || next >= srvN) return;
                srvLocked = true;
                srvGoTo(next);
            });

            document.addEventListener('keydown', function (e) {
                if (!srvActive) return;
                if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
                var dir = e.key === 'ArrowDown' ? 1 : -1;
                var next = srvPhase + dir;
                if (next < 0 || next >= srvN) return;
                e.preventDefault();
                if (srvLocked) return;
                srvLocked = true;
                srvGoTo(next);
                unlockScrollAfterDelay(750);
            });
        }

        // battery time section
        var batterySection = document.querySelector('.mtw5-battery-time-section');
        var batteryH2 = batterySection && batterySection.querySelector('h2');
        var batterySpan = batteryH2 && batteryH2.querySelector('.blue');
        var batteryP = batterySection && batterySection.querySelector('.body-text');

        if (batterySection && batteryH2) {
            const batteryCountNo = parseInt($("#batteryCount").text(), 10);
            var batteryCount = { val: 0 };

            if (batterySpan) batterySpan.textContent = '0';

            var batteryTl = gsap.timeline({
                scrollTrigger: {
                    trigger: batterySection,
                    start: 'top top',
                    end: 'bottom top',
                    pin: true,
                    anticipatePin: 1,
                    scrub: 0.5,
                }
            });

            batteryTl.fromTo(batteryH2,
                { opacity: 0, y: 400 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 2,
                    ease: 'power3.out',
                }
            );

            var batteryCount = { val: 0 };

            if (batterySpan) {
                batterySpan.textContent = '0';
            }

            batteryTl.to(batteryCount, {
                val: 10,
                duration: 1,
                ease: 'none',
                onUpdate: function () {
                    if (batterySpan) {
                        batterySpan.textContent = Math.round(batteryCount.val);
                    }
                }
            });

            batteryTl.to(batteryCount, {
                val: 24,
                duration: 1,
                ease: 'none',
                onUpdate: function () {
                    if (batterySpan) {
                        batterySpan.textContent = Math.round(batteryCount.val);
                    }
                }
            });

            batteryTl.to(batteryCount, {
                val: 36,
                duration: 1,
                ease: 'none',
                onUpdate: function () {
                    if (batterySpan) {
                        batterySpan.textContent = Math.round(batteryCount.val);
                    }
                }
            });

            batteryTl.to(batteryCount, {
                val: 40,
                duration: 1,
                ease: 'none',
                onUpdate: function () {
                    if (batterySpan) {
                        batterySpan.textContent = Math.round(batteryCount.val);
                    }
                }
            });

            batteryTl.to(batteryCount, {
                val: 40,
                duration: 1,
                ease: 'none',
                onUpdate: function () {
                    if (batterySpan) {
                        batterySpan.textContent = Math.round(batteryCount.val);
                    }
                }
            });

            if (batteryP) {
                var splitBattery = new SplitText(batteryP, { type: 'words', wordsClass: 'word' });

                batteryTl.fromTo(batteryP,
                    { opacity: 0, y: 400 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 2,
                        ease: 'power3.out',
                    }
                );

                batteryTl.fromTo(splitBattery.words,
                    { color: '#818183' },
                    {
                        color: '#ffffff',
                        ease: 'power3.out',
                        delay: 0.2,
                        stagger: { each: 0.4, from: 'start' },
                    },
                    '+=0.3');
            }

        }

        // crystal-clear-section
        function initCrystalAnimation(section) {

            var crystalSection = section;
            var crystalTitle = crystalSection.querySelector("h2");
            var crystalP = crystalSection.querySelector(".caption-wrap p");
        
            if (!crystalTitle) return;
        
            var crystalTl = gsap.timeline({
                scrollTrigger: {
                    trigger: crystalSection,
                    start: "top top",
                    end: "+=200%",
                    pin: true,
                    anticipatePin: 1,
                    scrub: 0.5,
                }
            });
        
            crystalTl.fromTo(
                crystalTitle,
                {
                    opacity: 0,
                    y: "100%"
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.4,
                    ease: "power3.out"
                }
            );
        
            if (crystalP) {
        
                var splitCrystal = new SplitText(crystalP, {
                    type: "words",
                    wordsClass: "word"
                });
        
                gsap.set(splitCrystal.words, {
                    color: "#818183"
                });
        
                crystalTl.fromTo(
                    crystalP,
                    {
                        opacity: 0,
                        y: "100%"
                    },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.4,
                        ease: "power3.out"
                    },
                    "<0.2"
                );
        
                crystalTl.to(splitCrystal.words, {
                    color: "#ffffff",
                    duration: 0.3,
                    ease: "power3.out",
                    stagger: {
                        each: 0.05,
                        from: "start"
                    }
                });
            }
        
        }
        $(".mtw5-crystal-clear-section").each(function () {
            initCrystalAnimation(this);
        });

        // replacable battery section
        function initSequentialTextAnimation(section) {

            var $section = $(section);
        
            var line1 = $section.find(".mtw5-driver-line-1");
            var line2 = $section.find(".mtw5-driver-line-2");
            var caption = $section.find(".caption-wrap h2");
        
            if (!line1.length || !line2.length || !caption.length) return;
        
            gsap.set([line1, line2, caption], {
                opacity: 0,
                y: "100%"
            });
        
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "+=300%",
                    pin: true,
                    anticipatePin: 1,
                    scrub: 0.5
                }
            });
        
            // Frame 1 - Hold
            tl.to({}, {
                duration: 0.6
            });
        
            // Frame 2 - First Line
            tl.to(line1, {
                opacity: 1,
                y: 0,
                duration: 0.4,
                ease: "power3.out"
            });
        
            // Frame 3 - Second Line
            tl.to(line2, {
                opacity: 1,
                y: 0,
                duration: 0.4,
                ease: "power3.out"
            });
        
            // Frame 4 - Hide Both
            tl.to([line1, line2], {
                opacity: 0,
                y: "-100%",
                duration: 0.4,
                ease: "power3.out"
            });
        
            // Frame 5 - Caption
            tl.to(caption, {
                opacity: 1,
                y: 0,
                duration: 0.4,
                ease: "power3.out"
            });
        
        }
        $(".mtw5-replaceable-battery-section").each(function () {
            initSequentialTextAnimation(this);
        });

    } else {

        // =========================================================
        // MTW5 MOBILE / TABLET ANIMATIONS
        // Based on M5 mobile behaviour, adapted for MTW5 structure
        // No pinning / no wheel locking on mobile
        // =========================================================
    
        function mobileFadeIn(elements, options) {
    
            var els = (Array.isArray(elements) ? elements : [elements])
                .filter(Boolean);
    
            if (!els.length) return;
    
            options = options || {};
    
            var stagger = options.stagger !== undefined ? options.stagger : 120;
            var duration = options.duration !== undefined ? options.duration : 0.7;
            var y = options.y !== undefined ? options.y : 30;
            var threshold = options.threshold !== undefined ? options.threshold : 0.12;
            var once = options.once !== undefined ? options.once : true;
    
            els.forEach(function (el) {
    
                gsap.set(el, {
                    opacity: 0,
                    y: y
                });
    
            });
    
            var observer = new IntersectionObserver(function (entries, obs) {
    
                entries.forEach(function (entry) {
    
                    if (!entry.isIntersecting) return;
    
                    var el = entry.target;
                    var index = els.indexOf(el);
    
                    gsap.to(el, {
                        opacity: 1,
                        y: 0,
                        duration: duration,
                        delay: index * (stagger / 1000),
                        ease: 'power3.out',
                        overwrite: true
                    });
    
                    if (once) {
                        obs.unobserve(el);
                    }
    
                });
    
            }, {
                threshold: threshold,
                rootMargin: '0px 0px -40px 0px'
            });
    
            els.forEach(function (el) {
                observer.observe(el);
            });
    
        }
    
    
        // =========================================================
        // VIDEO PLAYBACK
        // =========================================================
    
        function initMobileVideoPlayback(section) {
    
            if (!section) return;
    
            var videos = section.querySelectorAll('video.mobile');
    
            if (!videos.length) return;
    
            videos.forEach(function (video) {
    
                // Don't force opacity on the video itself.
                // Some MTW5 sections already use video opacity in
                // their desktop animation logic.
                video.pause();
    
                try {
                    video.currentTime = 0;
                } catch (e) {}
    
            });
    
            var observer = new IntersectionObserver(function (entries) {
    
                entries.forEach(function (entry) {
    
                    if (!entry.isIntersecting) {
    
                        videos.forEach(function (video) {
                            video.pause();
                        });
    
                        return;
                    }
    
                    videos.forEach(function (video) {
    
                        if (video.readyState >= 2) {
                            video.play().catch(function () {});
                        } else {
    
                            video.addEventListener('canplay', function () {
                                video.play().catch(function () {});
                            }, {
                                once: true
                            });
    
                        }
    
                    });
    
                });
    
            }, {
                threshold: 0.15,
                rootMargin: '0px 0px -10% 0px'
            });
    
            observer.observe(section);
    
        }
    
    
        // =========================================================
        // INTRO
        // =========================================================

        var introSection = document.querySelector('.mtw5-intro-section');

        if (introSection && $("body").find("mtw5-exp-page")) {

            var introObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {

                    if (entry.isIntersecting) {
                        $("body").removeClass("mtw5-discover-active");
                    }

                });
            }, {
                threshold: 0.1
            });

            introObserver.observe(introSection);
        }

        var discoverSection = document.querySelector('.mtw5-discover-text-section');

        if (discoverSection && $("body").find("mtw5-exp-page")) {

            var discoverObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {

                    if (entry.isIntersecting) {
                        $("body").addClass("mtw5-discover-active");
                    }

                });
            }, {
                threshold: 0.1
            });

            discoverObserver.observe(discoverSection);
        }
    
        mobileFadeIn([
            document.querySelector('.mtw5-intro-content')
        ], {
            duration: 0.8,
            y: 30
        });
    
        mobileFadeIn([
            document.querySelector('.mtw5-intro-para-1'),
            document.querySelector('.mtw5-intro-para-2')
        ], {
            stagger: 150,
            duration: 0.7,
            y: 25
        });
    
    
        // Intro video
        initMobileVideoPlayback(
            document.querySelector('.mtw5-intro-section')
        );
    
    
        // =========================================================
        // DISCOVER TEXT
        // =========================================================
    
        mobileFadeIn([
            document.querySelector('.mtw5-discover-text-section p')
        ], {
            duration: 0.9,
            y: 35
        });
    
    
        // =========================================================
        // PRODUCT EXPANDED
        // =========================================================
    
        mobileFadeIn([
            document.querySelector('.mtw5-product-expanded-section h2'),
            document.querySelector('.mtw5-product-expanded-section .caption-wrap')
        ], {
            stagger: 150,
            duration: 0.7,
            y: 30
        });
    
        initMobileVideoPlayback(
            document.querySelector('.mtw5-product-expanded-section')
        );
    
    
        // =========================================================
        // LOSSLESS / ATMOS
        // =========================================================
    
        document
            .querySelectorAll('.mtw5-lossless-section')
            .forEach(function (section) {
    
                mobileFadeIn([
                    section.querySelector('.content-wrap')
                ], {
                    duration: 0.7,
                    y: 30
                });
    
                initMobileVideoPlayback(section);
    
            });
    
    
        // =========================================================
        // ADAPTIVE NOISE
        // MTW5 has TWO titles + TWO mobile backgrounds
        // =========================================================
    
        
        var adaptiveSection = document.querySelector(
            '#mtw5-adaptive-noise-section'
        );

        if (adaptiveSection) {

            // Use the mobile images if available.
            // Otherwise fall back to the normal bg layers.
            var bg1 = adaptiveSection.querySelectorAll(
                '.bg-layer.bg1'
            );

            var bg2 = adaptiveSection.querySelectorAll(
                '.bg-layer.bg2'
            );

            var title1 = adaptiveSection.querySelectorAll('.title-1');
            var title2 = adaptiveSection.querySelectorAll('.title-2');

            if (bg1 && bg2 && title1 && title2) {

                // -----------------------------------------
                // Initial state
                // -----------------------------------------

                gsap.set(bg1, {
                    opacity: 1
                });

                gsap.set(bg2, {
                    opacity: 0
                });

                gsap.set(title1, {
                    opacity: 0,
                    y: 30
                });

                gsap.set(title2, {
                    opacity: 0,
                    y: 30
                });


                // -----------------------------------------
                // Run animation once section enters viewport
                // -----------------------------------------

                var adaptivePlayed = false;

                var adaptiveObserver = new IntersectionObserver(
                    function (entries, observer) {

                        entries.forEach(function (entry) {

                            if (!entry.isIntersecting || adaptivePlayed) {
                                return;
                            }

                            adaptivePlayed = true;

                            observer.unobserve(entry.target);


                            // ---------------------------------
                            // FRAME 1
                            // Image 1 visible
                            // ---------------------------------

                            gsap.set(bg1, {
                                opacity: 1
                            });

                            gsap.set(bg2, {
                                opacity: 0
                            });


                            // ---------------------------------
                            // FRAME 2
                            // Title 1 appears
                            // ---------------------------------

                            gsap.to(title1, {
                                opacity: 1,
                                y: 0,
                                duration: 0.5,
                                ease: 'power3.out',

                                onComplete: function () {

                                    // Hold title 1 briefly
                                    gsap.delayedCall(0.5, function () {

                                        // ---------------------------------
                                        // Title 1 disappears
                                        // Image 1 disappears
                                        // Image 2 appears
                                        // ---------------------------------

                                        var transitionTl = gsap.timeline();

                                        transitionTl.to(title1, {
                                            opacity: 0,
                                            y: -30,
                                            duration: 0.5,
                                            ease: 'power3.in'
                                        });

                                        transitionTl.to(bg1, {
                                            opacity: 0,
                                            duration: 0.5,
                                            ease: 'power3.inOut'
                                        }, '<');

                                        transitionTl.to(bg2, {
                                            opacity: 1,
                                            duration: 0.5,
                                            ease: 'power3.inOut'
                                        }, '<');


                                        // ---------------------------------
                                        // FRAME 3
                                        // Title 2 appears
                                        // ---------------------------------

                                        transitionTl.to(title2, {
                                            opacity: 1,
                                            y: 0,
                                            duration: 0.5,
                                            ease: 'power3.out'
                                        }, '>-0.2');

                                    });

                                }

                            });

                        });

                    },
                    {
                        threshold: 0.25,
                        rootMargin: '0px 0px -10% 0px'
                    }
                );

                adaptiveObserver.observe(adaptiveSection);
            }
        }
    
    
        // =========================================================
        // ANC
        // =========================================================
    
        var ancSections = document.querySelectorAll(
            '.mtw5-lossless-section'
        );
    
        // Video playback already handled above.
        // Content animation is handled independently.
    
    
        // =========================================================
        // LOSSLESS DETAIL
        // =========================================================
    
        var losslessDetail = document.querySelector(
            '.mtw5-crystal-clear-section.with-lossless-anc'
        );
    
        if (losslessDetail) {
    
            mobileFadeIn([
                losslessDetail.querySelector('h2'),
                losslessDetail.querySelector('.caption-wrap p')
            ], {
                stagger: 150,
                duration: 0.7,
                y: 30
            });
    
            initMobileVideoPlayback(losslessDetail);
    
        }
    
    
        // =========================================================
        // COMFORT FIT
        // =========================================================
    
        var comfortFitSections = document.querySelectorAll(
            '.mtw5-lossless-section'
        );
    
        // Already initialized above.
        // Keep video behaviour reusable for all repeated sections.
    
    
        // =========================================================
        // BATTERY
        // =========================================================
    
        var batterySection = document.querySelector(
            '.mtw5-battery-time-section'
        );
    
        if (batterySection) {
    
            mobileFadeIn([
                batterySection.querySelector('h2'),
                batterySection.querySelector('.body-text')
            ], {
                stagger: 150,
                duration: 0.8,
                y: 35
            });
    
        }
    
    
        // =========================================================
        // REPLACEABLE BATTERY
        // =========================================================
    
        var replaceableBattery = document.querySelector(
            '.mtw5-replaceable-battery-section'
        );
    
        if (replaceableBattery) {
    
            mobileFadeIn([
                replaceableBattery.querySelector(
                    '.mtw5-driver-line-1'
                ),
                replaceableBattery.querySelector(
                    '.mtw5-driver-line-2'
                ),
                replaceableBattery.querySelector(
                    '.caption-wrap h2'
                )
            ], {
                stagger: 150,
                duration: 0.7,
                y: 30
            });
    
            initMobileVideoPlayback(replaceableBattery);
    
        }
    
    
        // =========================================================
        // CRYSTAL CLEAR CALLS
        // =========================================================
    
        var crystalSections = document.querySelectorAll(
            '.mtw5-crystal-clear-section:not(.with-lossless-anc)'
        );
    
        crystalSections.forEach(function (section) {
    
            mobileFadeIn([
                section.querySelector('h2'),
                section.querySelector('.caption-wrap p')
            ], {
                stagger: 150,
                duration: 0.7,
                y: 30
            });
    
            initMobileVideoPlayback(section);
    
        });
    
    
        // =========================================================
        // SMART CONTROL PLUS APP
        // =========================================================
    
        mobileFadeIn([
            document.querySelector('.mtw5-sca-eyebrow'),
            document.querySelector('.mtw5-sca-heading')
        ], {
            stagger: 120,
            duration: 0.7,
            y: 30
        });
    
    
        // =========================================================
        // SOUND REVELATION
        // =========================================================
    
        var soundRevelation = document.querySelector(
            '#mtw5-sound-revelation-section'
        );
    
        if (soundRevelation) {
    
            mobileFadeIn([
                soundRevelation.querySelector(
                    '.mtw5-srv-headline'
                ),
                soundRevelation.querySelector(
                    '.mtw5-srv-para'
                ),
                soundRevelation.querySelector(
                    '.mtw5-srv-btn'
                )
            ], {
                stagger: 150,
                duration: 0.7,
                y: 30
            });
    
            initMobileVideoPlayback(soundRevelation);
    
        }
    
    
        // =========================================================
        // GENERIC FALLBACK
        // Play mobile videos when their section enters viewport
        // =========================================================
    
        document
            .querySelectorAll(
                'section:not(#mtw5-adaptive-noise-section) video'
            )
            .forEach(function (video) {
    
                var section = video.closest('section');
    
                if (!section) return;
    
                // Avoid duplicate observer for videos already initialized.
                if (section.dataset.mobileVideoInitialized === 'true') {
                    return;
                }
    
                section.dataset.mobileVideoInitialized = 'true';
    
                initMobileVideoPlayback(section);
    
            });
    
    }

    (function () {
        var bar = document.getElementById('page-progress-bar');

        function updateBar() {
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
            var progress = docHeight > 0 ? scrollTop / docHeight : 0;
            bar.style.width = (progress * 100) + '%';
        }

        window.addEventListener('scroll', updateBar, { passive: true });
        updateBar();
    })();
});